module.exports = __webpack_public_path__ + "assets/30db5d86c9d4a22a9b7a9b3415ee3f3b.png";